import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admininfo',
  templateUrl: './admininfo.component.html',
  styleUrls: ['./admininfo.component.css']
})
export class AdmininfoComponent implements OnInit {

  constructor(
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  IrAdmininfCHV(){
    this.router.navigate(['admininfochv']);
  }

  IrAdmininfFIVI(){
    this.router.navigate(['admininfofivi']);
  }

}
